'use strict';

var React = require('react');

var SvgExtendMinor = function SvgExtendMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m14.707 8.293 3 3a.997.997 0 0 1 0 1.414l-3 3a1 1 0 1 1-1.414-1.414l1.293-1.293h-4.586a1 1 0 0 1 0-2h4.586l-1.293-1.293a1 1 0 0 1 1.414-1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.293 4.293a1 1 0 1 1 1.414 1.414l-1.293 1.293h4.586a1 1 0 1 1 0 2h-4.586l1.293 1.293a1.002 1.002 0 0 1 0 1.414.998.998 0 0 1-1.414 0l-3-3a.997.997 0 0 1 0-1.414l3-3Z"
  }));
};

exports.SvgExtendMinor = SvgExtendMinor;
